import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import css from "./style.less";
import { useI18n } from "../../i18n/useI18n";
import ErrorComponent from "../ErrorComponent";
import { isReportingApi } from "../../utils/common";
import { routeURLs } from "../../utils/enums";

const PageNotFound = () => {
  const { tCommon } = useI18n('common');
  const navigate = useNavigate();
  const message = isReportingApi() ? tCommon('pageNotFound') : tCommon('pageNotFoundContact');

  useEffect(() => {
    navigate(routeURLs.notFound, {
      replace: true,
      state: {
        isInValid: true
      }
    });
  }, [navigate]);

  return (
    <ErrorComponent code={"404"} message={message} className={css["error_page_content"]} />
  );
}

export default PageNotFound;
